// extracted by mini-css-extract-plugin
export default {"form":"PatientFamilySearch_form__tWOr3","field":"PatientFamilySearch_field__fURI0","label":"PatientFamilySearch_label__qPxT7"};